import {get, each, set, size, first, camelCase} from 'lodash';


var DEFAULT_ERROR_CODE = 500;


/** Application error constructor */
var AppError = function (code, errorObject) {

  Error.call(this, null);

  this.errorCode = code || DEFAULT_ERROR_CODE;

  if (errorMessages.hasOwnProperty(this.errorCode)) {
    this.errorTitle = errorMessages[this.errorCode].title;
    this.errorMessage = errorMessages[this.errorCode].message;
  } else {
    this.errorTitle = null;
    this.errorMessage = null;
  }

  this.errorObject = errorObject || null;
  this.commonErrors = [];
  this.formErrors = {};

	this.modelState = get(errorObject, 'modelState', {});

	this.message = get(errorObject, 'message', {});

  if (this.errorCode === 400) {
    this.parseServerSideFormValidation(this.errorObject);
  }

};

AppError.prototype.parseModelState = function (modelState) {
  for (let key in modelState) {
    let paths = key.split('.');
    if (paths.length > 1 && !this.containsArrayPath(key)) {
      paths = paths.map(camelCase);
      set(this.formErrors, paths, first(modelState[key]))
    } else {
      this.commonErrors.push(...modelState[key])
    }
  }
};

AppError.prototype.containsArrayPath = function (str) {
  return /\[\d+\]/.test(str);
};

AppError.prototype.parseServerSideFormValidation = function (errorObject) {
  const modelState = get(errorObject, 'modelState');
  if (modelState) {
    this.parseModelState(modelState);
  }
};

AppError.prototype.getFormErrors = function (modelKey) {
  return get(this.formErrors, modelKey, {});
};

//error codes
AppError.CODE_UNAUTHORIZED = 401;
AppError.CODE_ACCESS_DENIDED = 403;
AppError.CODE_NO_AVAILABLE_MODULES = 418;
AppError.CODE_NOT_FOUND = 404;
AppError.CODE_SERVICE_ERROR = 500;
AppError.CODE_SERVICE_UNAVAIABLE = 503;

var errorMessages = {
  [AppError.CODE_NO_AVAILABLE_MODULES]: {
    title: "Access Denied",
    message: "There are not available modules for your user account. Please contact support@2eskimos.com."
  },

  403: {
    title: "Access Denied",
    message: "You do not have permission to view this page using the credentials that you supplied."
  },

  404: {
    title: 'We couldn\'t find the object requested (ref: 404)',
    message: "You have requested a page or file which doesn't exist anymore."
  },

  500: {
    title: "We couldn't complete your request (ref: 500).",
    message: "Our support team has been notified and will look into this if necessary. \n We recommend that you retry the action again shortly."
  },

  503: {
    title: "We couldn't complete your request (ref: 503).",
    message: "Our support team has been notified and will look into this if necessary. \n We recommend that you retry the action again shortly."
  },


  OBJECT_NOT_FOUND: {
    title: 'We couldn\'t find the object requested (ref: 404)',
    message: "You have requested a page or file which doesn't exist anymore."
  }

};



//error messages
AppError.messages = errorMessages;


AppError.isError = (object) => {
	return object instanceof AppError;
};

AppError.is400 = (object) => {
	return AppError.isError(object) ? object.errorCode === 400 : false;
}

AppError.is404 = (object) => {
  return AppError.isError(object) ? object.errorCode === 404 : false;
}

AppError.is409 = (object) => {
  return AppError.isError(object) ? object.errorCode === 409 : false;
}

AppError.isServerError = (object) => {
  return AppError.isError(object) && object.errorCode >= 500;
}

module.exports = AppError;
